import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { listMedia } from '../actions/mediaActions';
import Loader from '../components/Loader';
import Message from '../components/Message';
import CommercialCard from '../components/CommercialCard';
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import BetterSearchBar from "../components/BetterSearchBar";

const CommercialsScreen = ({ history, language, t }) => {
    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const commercials = useSelector((state) => state.commercialList);
    const { loading, commercialList, error } = commercials;
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredCommercials, setFilteredCommercials] = useState([]);
    const [radioValue, setRadioValue] = useState('search');

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(() => {
        dispatch(listMedia('commercials'));
    }, [dispatch]);

    useEffect(() => {
        if(commercialList) {
            filterCommercials(commercialList, searchQuery);
        }
    }, [searchQuery]);

    useEffect(() => {
        if (commercialList) {
            //console.log(commercialList);
            filterCommercials(commercialList, searchQuery);
        }
    }, [commercialList]);

    const filterCommercials = (commercialList, searchQuery) => {
        if (radioValue === 'search') {
            setFilteredCommercials(
                commercialList.filter((data) => {
                    const commercialName = data.name.toLowerCase();
                    return commercialName.includes(searchQuery.toLowerCase());
                })
            );
        } else {
            setFilteredCommercials(
                commercialList.filter((data) => {
                    const commercialTags = data.tags;
                    return (
                        JSON.stringify(commercialTags)
                            .toLowerCase()
                            .indexOf(searchQuery.toLowerCase()) !== -1
                    );
                })
            );
        }
    };

    return (
        <>
            <ThreeColumnRow main={true} secondColumn={t('commercials_title')} thirdColumn={<Link
                to='/commercials/create'
                className='btn btn-success m-0 p-2'
            >
                {t('commercials_create_commercial')}
            </Link>}/>

            <div className={'text-center mb-3'}>{filteredCommercials.length} {(filteredCommercials.length > 1 || filteredCommercials.length === 0) ? (t('commercials_commercials')) : (t('commercials_commercial'))}</div>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <>
                    <Row>
                        <BetterSearchBar
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                            radioValue={radioValue}
                            setRadioValue={setRadioValue}
                            language={language}
                            t={t}
                        />
                    </Row>
                    <Row>
                        {filteredCommercials.map((commercial) => (
                            <Col
                                key={commercial._id}
                                sm={12}
                                md={6}
                                lg={4}
                                xl={3}
                            >
                                <CommercialCard commercial={commercial} language={language} t={t}/>
                            </Col>
                        ))}
                    </Row>
                </>
            )}
        </>
    );
};

export default CommercialsScreen;
